import script from "./StorefrontCuration.vue?vue&type=script&setup=true&lang=js"
export * from "./StorefrontCuration.vue?vue&type=script&setup=true&lang=js"

import "./StorefrontCuration.vue?vue&type=style&index=0&id=c1562ef2&lang=scss"

const __exports__ = script;

export default __exports__